const nameRule = /^[a-z\u0080-\u024F]+(?:(?:\. |[' ])[a-z\u0080-\u024F]+)*$/i;
const addressRule = /(^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z0-9\u0080-\u024F ,\.-\/]*[a-zA-Z0-9\u0080-\u024F ]$)|(^\s*$)/;

export const RULES = {
  email: /(^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$)|(^\s*$)/i,
  password: /[^\s-]|[A-z]|[àĀ-ž]|\d|[!"#$%&'()*+-/:;=?@[\]^_{|}~‘’]/gm,
  phone: /^[(^((\+?)(\d+)((\s\d{1,8}|-\d{1,8}|\.\d{1,2}))+\d$)|(\+?\d+)\d$)|(^\s*$)]{5,16}$/,
  name: nameRule,
  firstName: nameRule,
  lastName: nameRule,
  companyName: /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~\s]{1,63}$/,
  businessName: /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~\s]{1,63}$/,
  attachment: [
    '.doc',
    '.docx',
    '.pdf',
    '.otf',
    '.rtf',
    '.zip',
    '.ppt',
    '.pptx',
    '.txt',
    '.rar',
  ],
  address: addressRule,
  city: addressRule,
  state: addressRule,
  url: new RegExp(
    // protocol identifier
    '(?:(?:https?|ftp)://)?' +
      // user:pass authentication
      '(?:\\S+(?::\\S*)?@)?' +
      '(?:' +
      // IP address exclusion
      // private & local networks
      '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
      '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
      '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
      // IP address dotted notation octets
      // excludes loopback network 0.0.0.0
      // excludes reserved space >= 224.0.0.0
      // excludes network & broacast addresses
      // (first & last IP address of each class)
      '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
      '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
      '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
      '|' +
      // host name
      '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
      // domain name
      '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
      // TLD identifier
      '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
      // sorry, ignore TLD ending with dot
      // "\\.?" +
      ')' +
      // port number
      '(?::\\d{2,5})?' +
      // resource path, excluding a trailing punctuation mark
      '(?:[/?#](?:\\S*[^\\s!"\'()*,-.:;<>?\\[\\]_`{|}~]|))?',
    'gi'
  ),
};

export const VALIDATION_ERRORS = {
  address: 'Please enter a real address.',
  attachment: `Please attach file of the following type ${RULES.attachment.join(
    ', '
  )}.`,
  email: 'Please enter a valid email address.',
  password: 'Please enter a valid password.',
  phone: 'Please enter a real phone number.',
  name: 'Please enter a real name.',
  firstName: 'Please enter a real first name.',
  lastName: 'Please enter a real last name.',
  companyName: 'Please enter a real company name.',
  businessName: 'Please enter a real company name.',
  country: 'Please enter a real country.',
  city: 'Please enter your city.',
  state: 'Please enter state.',
  url: 'Please enter a real website address.',
};

export const MAX_LENGTH = {
  firstName: 255,
  lastName: 255,
};

export const MAX_LENGTH_ERRRORS = {
  firstName: `First name is too long (maximum is ${MAX_LENGTH.firstName} characters).`,
  lastName: `Last name is too long (maximum is ${MAX_LENGTH.firstName} characters).`,
};

export const REQUIRED_ERRORS = {
  attachment: 'Please attach your CV.',
  email: 'Please enter your email address.',
  password: 'Please enter your password.',
  phone: 'Please enter your phone number.',
  name: 'Please enter your name.',
  firstName: 'Please enter your first name.',
  lastName: 'Please enter your last name.',
  address: 'Please enter your address.',
  companyName: 'Please enter your company name.',
  businessName: 'Please enter a real company name.',
  city: 'Please enter your city.',
  state: 'Please enter state.',
  country: 'Please enter country.',
  url: 'Please enter your address.',
  category: 'Please choose category.',
  terms: 'Please agree with our terms and conditions.',
  text: 'Please enter your enquiry.',
};

export const WITHOUT_VALIDATION = ['rememberMe'];
